<template>
    <div class="abosulte left-0 inset-y-0 flex flex-col md:flex-row md:items-center items-start md:mb-0 mb-3">
        <FilterBadge
            v-for="(value, name) in shownFilters"
            :key="`filter-${name}-${value}`"
            :filter-val="value"
            :filter-name="name"
            class="mr-4"
            @remove="removeFilter(name)"
        />
        <FiltersDropdown
            v-on:back="changeFilter('Filter by')"
            :title="filterTitle"
            :schedulerFilter="true"
            :active-filters="activeFilters"
            class="transition duration-300 ease-in-out rounded-full bg-payneHot text-white flex justify-center items-center font-medium px-5 h-10 border border-platinum focus:outline-none focus:border-yankFire focus:shadow-xl"
        >
            <template>
            <PlusIcon class="h-4"/>
            <span class="ml-3 font-normal">Filter</span>
            </template>
            <template slot="filters">  
            <div class="text-sm">
                <template v-if="filterType === 'Uploaded At'">
                <DateBetweenFilter @change="onDateRangeFilterChange"/>
                </template>
                <template v-else-if="filterType === 'Type'">
                <MimeTypeFilter
                    v-model="filters.type"
                    :enabled-filters="enabledFilters"
                    @change="onTypeFilterChange"
                />
                </template>
                <ul v-else class="px-4 py-2 text-sm">
                <li @click="changeFilter('Uploaded At')" class="flex items-center py-2 cursor-pointer"><CalendarFilter class="mr-3"/>Uploaded At</li>
                <li @click="changeFilter('Type')" class="flex items-center py-2 cursor-pointer"><CheckFilter class="mr-3"/>File Type</li>
                </ul>  
            </div>   
        </template>
        </FiltersDropdown>
    </div>
</template>
<script>
import FiltersDropdown from "@/components/shared/Common/FiltersDropdown"
import FilterBadge from "@/components/shared/FilterBadge"
import CalendarFilter from '@/components/svg/CalendarFilter'
import DateBetweenFilter from '@/components/scheduler/Filters/DateBetweenFilter'
import PlusIcon from '@/components/svg/PlusIcon'
import TypeFilter from '@/components/filters/TypeFilter'
import MimeTypeFilter from '@/components/my-media/Filters/MimeTypeFilter.vue'
import CheckFilter from '@/components/svg/CheckFilter'

export default {
    name: 'MyMediaFilters',

    components: {
        FiltersDropdown,
        FilterBadge,
        CalendarFilter,
        DateBetweenFilter,
        PlusIcon,
        TypeFilter,
        MimeTypeFilter,
        CheckFilter
    },

    props: {
        shownFilters: {
            type: Object,
            required: true
        },

        activeFilters: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            filterType: '',
            filterTitle:'Filter by',
            filters: {
                type: null,
            },
            enabledFilters: [],
            typeFilters: {
                type: Object,
                default: () => ({type: null})
            },
        }
    },

    methods: {
        changeFilter(filter){
            this.filterType = filter;
            this.filterTitle = filter;
        },

        onDateRangeFilterChange: function(data) {
            this.removeFilters(['date']);
            this.addFilter(data.filter, data.value);
        },

        onTypeFilterChange: function(data) {
            this.removeFilters(['type']);
            this.addFilter(data.filter, data.value);
        },

        addFilter(type, value) {
            this.$set(this.activeFilters, type, value);
            this.$emit('change');
        },

        removeFilters(filters) {
            filters.forEach((filter) => {
                delete this.activeFilters[filter];
            });
        },

        removeFilter(type) {
            delete this.activeFilters[type];
            this.$emit('change');
        },
    }
}
</script>